import "./locations.scss";
import { PathBasedBreadcrumb } from "../PathBasedBreadcrumb/PathBasedBreadcrumb";
import { observer } from "mobx-react-lite";
import { store } from "../../store/index.store";
import { Alert, Button, Spin } from "antd";
import { useRef, useState } from "react";
import { updateLocation } from "../../api/profile";

export const Location = observer(() => {
  const [location, setLocation] = useState<[number, number, number]>([0, 0, 0]);
  const [error, setError] = useState("");
  const [isLoadingLocation, setIsLoadingLocation] = useState(false);

  const locationWatchRef = useRef<null | number>(null);

  const { authStore } = store;

  const { userProfile } = authStore;

  const loadLocation = () => {
    setError("");
    setIsLoadingLocation(true);
    try {
      locationWatchRef.current = navigator.geolocation.watchPosition(
        (position) => {
          setLocation([
            position.coords.latitude,
            position.coords.longitude,
            position.coords.accuracy,
          ]);
          setIsLoadingLocation(false);
        },
        (e) => {
          setIsLoadingLocation(false);
          setError(e.message);
        },
        { maximumAge: Infinity, timeout: Infinity, enableHighAccuracy: false }
      );
    } catch (e) {
      setIsLoadingLocation(false);
    }
  };

  const updateLocationHndlr = async () => {
    if (location[0] === 0 && location[1] === 0) return;
    await updateLocation({
      lat: location[0],
      long: location[1],
    });
    authStore.updateLocation(location.slice(0, 2) as [number, number]);

    if (locationWatchRef.current) {
      navigator.geolocation.clearWatch(locationWatchRef.current);
    }
  };

  return (
    <div className="p-location-settings">
      <PathBasedBreadcrumb />
      <br />
      <h2>Location settings</h2>
      {error && <Alert message={error} type="error" showIcon />}
      {userProfile.location ? (
        <div>
          Curently set location: <span> </span>
          <span>
            Lat: {userProfile.location.coordinates[0]} Long:{" "}
            {userProfile.location.coordinates[1]}
          </span>
        </div>
      ) : (
        <div>No location set</div>
      )}

      <br />

      <Spin spinning={isLoadingLocation}>
        <p>
          Currently loaded location: Latitude: {location[0]} - Longitude:{" "}
          {location[1]} - Accuracy: {location[2]}
        </p>
      </Spin>

      <br />
      <span>
        <b>Node:</b> Set your home location while your are home, or the zone you
        want to sell the item, otherwise the item wont have any visibility
      </span>
      <br />
      <Button
        type="primary"
        onClick={loadLocation}
        className="p-location-settings__button"
      >
        Grab Current Location
      </Button>
      <br />
      <Button
        type="primary"
        onClick={updateLocationHndlr}
        className="p-location-settings__button"
      >
        Set Home Location
      </Button>
    </div>
  );
});
